var win = window;

export var caf = win.cancelAnimationFrame ||
  win.mozCancelAnimationFrame ||
  function(id) { clearTimeout(id); };



// WEBPACK FOOTER //
// ./app/assets/javascripts/components/tinySlider/lib/helpers/caf.js